import { gql } from '@apollo/client';

import META_FRAGMENT from '../fragments/meta';

export const GET_SINGLE_COMPANY = gql`
  query findOneCompanyEntity($id: String) {
    findOneCompanyEntity(id: $id) {
      id
      name
      address
      avatar {
        id
        thumbnailPipeFrom
        pipeFrom
      }
    }
  }
`;

export const GET_COMPANY_BY_INVOICE = gql`
  ${META_FRAGMENT}
  query getCompanies(
    $pagination: PageOptionsDto
    $order: CompanySortFields
    $query: String
    $hasBalance: Boolean
    $id: String
  ) {
    findInvoiceCompanyEntity(pagination: $pagination, order: $order, query: $query, hasBalance: $hasBalance, id: $id) {
      data {
        id
        name
        total
        paid
        appointmentCount
        balance
        avatar {
          id
          thumbnailPipeFrom
        }
        address
      }
      meta {
        ...MetaFragment
      }
    }
  }
`;

export const GET_COMPANY_FOR_TRANSACTION_TYPES_PRICES = gql`
  ${META_FRAGMENT}
  query findServiceTransactionTypeCompanyEntity(
    $pagination: PageOptionsDto
    $transactionType: String!
    $query: String # $status: StatusType
  ) {
    findServiceTransactionTypeCompanyEntity(
      pagination: $pagination
      transactionType: $transactionType
      query: $query # status: $status
    ) {
      data {
        id
        name
        avatar {
          id
          thumbnailPipeFrom
        }
        specificPrices(transactionType: $transactionType) {
          priceRON
          priceInPerson
        }
      }
      meta {
        ...MetaFragment
      }
    }
  }
`;
